<template>
  <div class="jijin-box">
    <div v-if="false">
      <div class="jijin-content">
        <div class="jijin-title" v-if="list.length > 0 && list[0]">
          <div style="overflow-x: auto;" class="scroll-view">
            <div class="scroll-view_box">
              <div class="item flex-conter" v-for="(item, index) in list" :key="index"
                :class="index === current ? 'current' : ''" @click="cut(item, index)">
                <img src="http://images.snsports.cn/bsn_lx_icon.png" alt="">
                <p class="overflow-text-two"
                  :style="{ width: item.title.length < 8 ? '50px' : '85px', color: index === current ? '#FF613B' : '' }">
                  {{
                    item.title }}</p>
                <img src="http://images.snsports.cn/bsn_zb_icon.png" class="icon" v-if="index === current">
              </div>
            </div>
          </div>
        </div>
        <div class="jijin-classify">
          <div class="item" :style="{ color: index === 0 ? '#F94242' : '', fontWeight: index === 0 ? '700' : '' }"
            @click="updata(0)">全部<span>{{ lives.length }}</span></div>
          <div class="item" :style="{ color: index === 1 ? '#F94242' : '', fontWeight: index === 1 ? '700' : '' }"
            @click="updata(1)">得分<span>{{ scoreList.length }}</span></div>
          <div class="item" :style="{ color: index === 2 ? '#F94242' : '', fontWeight: index === 2 ? '700' : '' }"
            @click="updata(2)">精彩<span>{{ wonderfulList.length }}</span></div>
        </div>
        <div class="jijin-list">
          <div class="item flex-conter" v-for="(item, index) in videoList" :key="item.id" @click="cutList(item, index)">
            <div class="video">
              <img class="img" :src="item.poster" />
              <div class="icon">
                <div>{{ item.duration }}</div>
              </div>
            </div>
            <div class="title">
              <p class="overflow-text-two" :style="{ color: listIndex === index ? '#FF613B' : '' }">{{ item.title }}</p>
              <div class="data flex-conter">
                <p class="flex-conter">
                  <img src="http://images.snsports.cn/bsn_ browse_icon.png" />
                  {{ item.pvCount }}
                </p>
                <p class="flex-conter">
                  <img src="http://images.snsports.cn/bsn_date_icon.png" />
                  {{ item.createDate }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="jijin-pl" v-if="false">
          <div class="title">评论（3）</div>
          <div class="pl-list">
            <div class="item">
              <div class="t1 flex-conter">
                <img class="tx-img"
                  src="http://live.banmabang.cn/recordings/z1.banmalive.game_525197/1559368783_1559374275.mp4.poster.10.png" />
                <div class="box">
                  <p>啊哈哈哈哈哈</p>
                  <span>7月23日</span>
                </div>
                <div class="flex-conter dz">
                  <img src="http://images.snsports.cn/bsn_dz2_icon.png" />
                  <span>1</span>
                </div>
              </div>
              <div class="t2 flex-conter">
                <p>66666</p>
                <div>回复</div>
              </div>
            </div>
            <div class="item">
              <div class="t1 flex-conter">
                <img class="tx-img"
                  src="http://live.banmabang.cn/recordings/z1.banmalive.game_525197/1559368783_1559374275.mp4.poster.10.png" />
                <div class="box">
                  <p>啊哈哈哈哈哈</p>
                  <span>7月23日</span>
                </div>
                <div class="flex-conter dz">
                  <img src="http://images.snsports.cn/bsn_dz1_icon.png" />
                  <span>2</span>
                </div>
              </div>
              <div class="t2 flex-conter">
                <p>66666</p>
                <div>回复</div>
              </div>
            </div>
          </div>
          <div class="unfold">查看更多</div>
          <div style="height: 12px;background: #F7F7FB;"></div>
          <div class="info flex-conter">
            <img :src="infoImg" class="tx" />
            <input type="text" placeholder="我来说几句...">
            <img src="http://images.snsports.cn/bsn_fx_icon.png" class="fx" />
          </div>
        </div>
      </div>
      <div v-if="(list.length === 0 || !list[0]) && videoList.length === 0" class="jijin-kong flex-conter"
        style="flex-direction: column;">
        <img src=" http://images.snsports.cn/bsn_kong.png" class="kong" />
        <p>本场次暂无集锦</p>
      </div>
    </div>
    <div v-else class="empty">
      比赛直播中～
      <div>更多精彩集锦请在直播结束后观看</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    whole: {
      type: Object,
      default: () => { }
    },
    cols: {
      type: Array,
      default: () => []
    },
    lives: {
      type: Array,
      default: () => []
    },
    infoImg: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      list: [],
      index: 0,
      current: 0,
      scoreList: [],
      wonderfulList: [],
      videoList: [],
      listIndex: null
    }
  },
  watch: {
    whole: {
      handler(newValue) {
        this.list.push(newValue)
      }
    },
    cols: {
      handler(newValue) {
        this.list.push(...newValue)
      }
    },
    lives: {
      handler(newValue) {
        this.videoList = newValue
        const list = newValue.reduce((obj, item) => {
          if (item.tags === '精彩') {
            obj.wonderful.push(item)
          } else if (item.tags === '得分' || item.tags === '进球') {
            obj.score.push(item)
          }
          return obj
        }, { score: [], wonderful: [] })
        this.scoreList = list.score
        this.wonderfulList = list.wonderful
      },
      deep: true
    }
  },
  methods: {
    cut(obj, index) {
      this.current = index
      this.$emit('videoUrl', obj.url)
    },
    cutList(obj, index) {
      this.current = null
      this.listIndex = index
      this.$emit('videoUrl', obj.url)
    },
    updata(i) {
      this.index = i
      if (i === 0) {
        this.videoList = this.lives
      } else if (i === 1) {
        this.videoList = this.scoreList
      } else if (i === 2) {
        this.videoList = this.wonderfulList
      }
    }
  }
}
</script>

<style scoped lang="scss">
.jijin-box {
  background-color: #F7F7FB;

  .empty {
    text-align: center;
    padding: 24px;
    font-size: 12px;
    color: #646566;

    div {
      margin-top: 12px;
    }
  }

  .jijin-content {
    .jijin-title {
      background-color: #fff;
      padding: 16px 12px 12px 12px;
      border-top: 1px solid #EEEEEE;
      margin-bottom: 10px;

      .scroll-view {
        &::-webkit-scrollbar {
          display: none;
        }
      }

      .scroll-view_box {
        display: flex;
      }

      .item {
        height: 48px;
        border-radius: 3px;
        margin-right: 9px;
        background: #F7F7F7;
        padding: 10px;
        font-size: 11px;
        box-sizing: border-box;

        p {
          min-width: 44px;
          width: 85px;
        }

        img {
          width: 14px;
          height: 14px;
          min-width: 14px;
          margin-right: 4px;
        }
      }

      .current {
        position: relative;
        border: 1px solid #F95252;
        background: #FFF4F4;

        .icon {
          position: absolute;
          right: 4px;
          bottom: 4px;
          width: 10px;
          height: 6px;
          margin: 0;
        }
      }
    }

    .jijin-classify {
      background-color: #fff;
      padding: 16px 12px;
      position: relative;
      display: flex;

      &::before {
        position: absolute;
        top: 18px;
        content: '';
        display: block;
        width: 4px;
        height: 16px;
        background: #F94242;
      }

      .item {
        color: #8C8C8C;
        width: 61px;
        padding: 0 12px;
        padding-left: 19px;
        position: relative;

        span {
          position: absolute;
          font-size: 9px;
          left: 52px;
          top: 0px;
        }
      }
    }

    .jijin-list {
      background-color: #fff;
      margin-bottom: 12px;

      .item {
        padding: 8px 13px 13px 11px;
        border-top: 1px solid #EEEEEE;

        .video {
          position: relative;
          width: 125px;
          min-width: 125px;
          height: 76px;
          border-radius: 3px;
          overflow: hidden;

          .img {
            width: 125px;
            height: 76px;
          }

          .icon {
            position: absolute;
            width: 100%;
            bottom: 0;
            width: 125px;
            height: 18.5px;
            background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
            border-radius: 0px 0px 2px 2px;
            opacity: 0.7;

            div {
              color: #FFFFFF;
              font-size: 8.5px;
              text-align: right;
              padding-right: 7px;
              position: relative;

              &::before {
                position: absolute;
                right: 32px;
                top: 1px;
                content: '';
                display: block;
                width: 0px;
                height: 0px;
                border-top: 4px solid transparent;
                /* 修改这里的数值可以改变三角形大小 */
                border-bottom: 4px solid transparent;
                border-left: 5px solid #fff;
              }
            }
          }
        }

        .title {
          margin-left: 12px;
          height: 76px;
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          p {
            font-size: 16px;
            color: #191919;
            padding: 0;
            margin: 0;
          }

          .data {
            margin-top: 10px;

            p {
              color: #8C8C8C !important;
            }

            font-size: 14px;

            img {
              width: 14px;
              height: 14px;
              margin-right: 4px;
            }
          }
        }
      }
    }

    .jijin-pl {
      background-color: #fff;

      .title {
        padding: 18px 31px;
        position: relative;

        &::before {
          content: '';
          position: absolute;
          top: 20px;
          left: 12px;
          width: 4px;
          height: 16px;
          background: #F94242;

        }
      }

      .pl-list {
        .item {
          padding: 16px 12px;
          padding-bottom: 0;
          border-top: 1px solid #EEEEEE;

          .t1 {
            .tx-img {
              width: 30px;
              height: 30px;
              border-radius: 50%;
            }

            .box {
              flex: 1;
              padding: 0 12px;

              p {
                font-size: 14px;
                font-weight: 600;
                color: #3C3C3C;
              }

              span {
                font-size: 11px;
                color: #B6B6B6;
              }
            }

            .dz {
              img {
                width: 16px;
                height: 16px;
                margin-right: 2px;
              }
            }
          }

          .t2 {
            padding: 16px 0px 16px 42px;

            p {
              color: #323232;
              font-size: 14px;
            }

            div {
              width: 45px;
              height: 19px;
              line-height: 19px;
              background: #F2F1F1;
              border-radius: 9px;
              font-size: 11.5px;
              color: #323232;
              text-align: center;
            }
          }
        }
      }

      .unfold {
        padding: 16px;
        text-align: center;
        font-size: 12px;
        color: #F94242;
        border-top: 1px solid #EEEEEE;
      }

      .info {
        padding: 17px 14px 13px 13px;

        .tx {
          width: 27px;
          height: 27px;
          border-radius: 50%;
          margin-right: 8px;
        }

        input {
          flex: 1;
          background: #FAFAFB;
          padding: 8px 12px;
          border-radius: 18px;
          font-size: 14px;
        }

        .fx {
          width: 24px;
          height: 24px;
          margin-left: 10px;
        }
      }
    }
  }

  .jijin-kong {
    padding-top: 36px;
    border-top: 1px solid #EEEEEE;
    background-color: #fff;

    .kong {
      width: 120px;
      height: 120px;
    }

    .box {
      width: 279px;
      height: 56px;
      background: #FFFFFF;
      border-radius: 30px;
      border: 1px solid #FFA089;
      text-align: center;
      margin-top: 16px;

      span {
        color: #FFA089;
        font-size: 12px;
      }

      div {
        font-size: 16px;
        font-weight: 600;
        color: #FF613B;
        width: 90px;
        margin: 0px auto;
        margin-top: 7px;
      }

      img {
        width: 16px;
        height: 16px;
        margin-right: 10px;
      }
    }

    p {
      color: #B9BAB9;
      font-size: 14px;
    }
  }
}

.flex-conter {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.overflow-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
}

.overflow-text-two {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
</style>
